<template>
<div>
    <!-- <headerComponent/> -->
    <div class="pageContainer">
        <!-- <carousel :perPage="1" :autoplay="true" :loop="true" style="height:540px">  
            <slide v-for="image in images" :key="image">  
                <img :src="require(`${image}`)" alt="carousel image">  
            </slide>  
        </carousel>   -->
         <img :src="curImg.src" alt="" srcset="" style="width:100%;"  class="animate__animated animate__slideInLeft">

    </div>
    <div class="containerOne" style="width:100%;min-height:820px;margin:45px 0 0 0">
      <div style="width:1300px;margin:0 auto">
        <!-- <img src="@/views/solution/images/group02.png" alt="" srcset="" style="width:100%;padding:30px 0 0px 0;display:block;margin-bottom:60px;"> -->
        <!-- 公共组建开始 -->
        <module-tit title="Videos" subTitle="视频中心" titleStyle="width:315px" subTitleStyle="width:985px"/>
        <!-- 公共组件结束 -->

        <!-- <div v-html="videoObj"></div> -->
        <div class="one" style="position:relative;width:100%;" v-for="(item,index) in videoArr" :key="index">
            <video ref="videoPlayer" width="100%" height="740" controls :poster="item.thumb" >  
              <source :src="`${item.video_url}`" type="video/mp4">  
              您的浏览器不支持 Video 标签。  
            </video>  
          <div class="module" style="padding:60px 0 0 0;border-bottom:1px solid #000;height:100px;">
           <span class="tit" style="display:block;float:left;font-size:24px;font-weight:700">{{item.title}}</span>
           <span style="display:block;float:right;font-weight:300">{{item.timeline}}</span>
          </div>
        </div>
        <!-- <div class="one" style="position:relative;width:100%;">
          <video ref="videoPlayer" width="100%" height="500" controls>  
              <source src="@/views/video/video02.mp4" type="video/mp4">  
              您的浏览器不支持 Video 标签。  
            </video> 
          <div class="module" style="padding:60px 0 0 0;border-bottom:1px solid #000;height:100px;">
           <span class="tit" style="display:block;float:left;font-size:24px;font-weight:700">正念生活～我们一起好状态</span>
           <span style="display:block;float:right;font-weight:300">2023.09.30</span>
          </div>
        </div> -->
        <div class="clearBoth"></div>
        
      </div>
    </div>
</div>
</template>
<script>
import { getList,cate  } from '@/api/index.js'
import moduleTit from '@/components/moduleTit'
import { getRouterQuery } from '@/utils/index.js'
export default {
  name: 'App',
   components:{
    moduleTit
  },
  data() {  
    return {  
      videoArr:[],
      curImg:{}
    };  
  }, 
  mounted() {
    this.getIndexEvent()
    this.cateEvent()
  },
  methods:{
    cateEvent() {
      cate().then((res)=>{
          this.curImg = this.filterItemsByPath('/#/video',res.data).banner[0]
      })
    },
    filterItemsByPath(path,arr) {
      let _arr = []
      let newArr = []
      _arr = arr
      newArr =  _arr.filter(item => item.path === path);
      if (newArr.length > 0) {
        return newArr[0]; // 只取第一个匹配的对象
      } else {
        return {}; // 如果没有匹配的对象，返回空对象
      }
  },
    getIndexEvent() {
      const self = this
      this.$nextTick(()=>{
          let _id = getRouterQuery('id')

          let obj = {cateId:_id}
            getList(obj).then((res)=>{
                this.videoArr = res.data.data
            })
        })
    },
  }
}
</script>
<style lang="scss" scoped>
.containerOne{
  .one{
    width:100%;
    margin:0 0 50px 0
  }
}
.footWords{
  padding:20px 0;
  line-height: 30px;
}
.clearBoth {
  clear:both
}
.tit {
  margin:0 0 20px 0;
  span{
    display: block;
    padding:5px 0 10px 0;
  }
}
</style>
